import React,{ useEffect, useState } from 'react';
import styles from './styles.scss';
import Empty from '@/components/empty';
import Error from '@/components/Error';
import { history } from 'umi';
import {getProgramComments,sendComment,deleteComment,likeComment,sendReplyComment } from '@/services/program';
import { Toast } from 'antd-mobile';
import {InfiniteLoader } from 'react-weui';
import { getLoginUser } from '@/utils/login';




export default (props) => {
  const {program,getCommentCount} = props;
  const [commentList,setCommentList] = useState([]);
  const [error, setError] = useState(null);
  const [commentText, setCommentText] = useState('');
  const [replyComment, setReplyComment] = useState(null);

  const [pageNo,setPageNo] = useState(1);
  const [totalCount, setTotalCount] = useState(0); // 新增总条数

  useEffect(()=>{
    getComments(1);
  },[]);

  function getComments(pageNo,resolve,finish) {
    getProgramComments({columnId:program.id,pageNo:pageNo,pageSize:20}).then(res => {
      console.log(res);

      if (res && res.code == 200) {
        setTotalCount(res.data.count || 0); // 更新总条数
        if (pageNo == 1) {
          setCommentList(res.data.list);
        } else {
          setCommentList(prev => prev.concat(res.data.list));
        }
        setError(null);
        setPageNo(pageNo);
        resolve && resolve();
        // 不再用list.length判断finish，由onLoadMore统一判断
        getCommentCount && getCommentCount(res.data.count);
      }else {
        setError(res.message);
        resolve && resolve();
      }
    }).catch(e => {
      setError('评论加载失败，请重试');
      resolve && resolve();
    });
  }


  function submitComment() {
    if (!commentText) {
      Toast.show('请输入评论内容',1);
      return;
    }
    Toast.loading('正在发送...',60);
    sendComment({columnId:program.id,content:commentText}).then(res => {
      Toast.hide();
      console.log(res);
      if (res.code == 200) {
        setCommentText('');
        getComments(1);
      } else {
        Toast.fail(res.message,1);
      }
    }).catch(e =>{
      Toast.hide();
      Toast.fail('评论失败，请重试',1);
    })
  }

  function submitReplyComment() {
    if (!commentText) {
      Toast.show('请输入评论内容',1);
      return;
    }

    Toast.loading('正在发送...',60);
    sendReplyComment({commentId:replyComment.id,content:commentText,replyMemberId:replyComment.memberId}).then(res => {
      Toast.hide();
      console.log(res);
      if (res.code == 200) {
        setCommentText('');
        setReplyComment(null);
        getComments(1);
      } else {
        Toast.fail(res.message,1);
      }
    }).catch(e =>{
      Toast.hide();
      Toast.fail('回复失败，请重试',1);
    })
  }



  return(
    <div className={styles.tabBox}>
      <InfiniteLoader onLoadMore={ (resolve, finish) => {
        if (commentList.length >= totalCount && totalCount !== 0) {
          finish();
          return;
        }
        getComments(pageNo+1,resolve,finish);
      }}>

        {error && <Error error={error} onRefresh={() =>{
          getComments(1);
        }}/>}

        {!error && (commentList.length ? commentList.map(item => (
            <CommentItem key={item.id} comment={item}
                         toReply={()=>{
                           setReplyComment(item);
                         }}
                         toRefresh={()=>{
                           getComments(1);
                         }}/>))
          : <Empty text={'暂无评论'}/>)}
        {commentList.length >= totalCount && totalCount !== 0 && (
          <div style={{ textAlign: 'center', color: '#888', padding: '12px 0' }}>
            没有更多数据了
          </div>
        )}
      </InfiniteLoader>

      <div className={styles.bottomBar}>
        <textarea className={styles.commentInput}
                  type='search'
                  value={commentText}
                  placeholder={replyComment? '回复@'+replyComment.member.nickname : '请输入评论'}
                  onChange={ e => {
                    setCommentText(e.target.value);
                  }}
        />


        <div className={styles.commentSend} onClick={()=>{
          if (replyComment) {
            submitReplyComment();
          } else {
            submitComment();
          }
        }}>发送</div>

      </div>
    </div>
  )
}


const CommentItem = (props) => {

  const {comment,toReply, toRefresh} = props;

  const user = getLoginUser();

  return(
    <div className={styles.commentItem}>
      <img className={styles.commentHead} src={comment.member.avatarurl}/>

      <div className={styles.commentContent}>

        <div style={{flexDirection:'row',alignItems:'center',display:'flex'}}>
          <label className={styles.commentUser}>{comment.member.nickname}</label>

          {user && user.id == comment.memberId &&
          <div className={styles.delButton} onClick={()=>{
            commentDelete(comment);
          }}>
            <img src={require('@/assets/close.png')}/>
          </div>}

        </div>

        <label className={styles.commentMsg}>{comment.content}</label>


        <CommentReply comment={comment}/>

        <div className={styles.commentBottom}>
          <label className={styles.commentTime}>{comment.createDate}</label>

          <img src={require('@/assets/ic_comment.png')} onClick={()=>{
            toReply && toReply(comment);
          }}/>

          <img src={comment.isLike == '0' ? require('@/assets/ic_like.png') : require('@/assets/ic_liked.png')}
               onClick={()=>{
                 commentLike(comment);
               }}
          />
          <label style={{color:comment.isLike == '0' ? '#666' : '#57B99D'}}>{comment.likeCount}</label>

        </div>
      </div>
    </div>
  )

  function commentLike(comment){
    Toast.loading('loading...',60);
    likeComment({commentId:comment.id}).then(res => {
      Toast.hide();
      if (res.code == 200) {
        toRefresh && toRefresh();
      } else {
        Toast.fail(res.message,1);
      }
    }).catch(e =>{
      Toast.hide();
      Toast.fail('点赞失败，请重试',1);
    })
  }

  function commentDelete(comment) {
    Toast.loading('删除中...',60);
    deleteComment({id:comment.id}).then(res => {
      Toast.hide();
      if (res.code == 200) {
        toRefresh && toRefresh();
      } else {
        Toast.fail(res.message,1);
      }
    }).catch(e =>{
      Toast.hide();
      Toast.fail('删除失败，请重试',1);
    })
  }
}


const CommentReply = (props) => {
  const {comment} = props;
  if (!comment.columnCommentReplyList || !comment.columnCommentReplyList.length) {
    return null;
  }
  return(
    <div className={styles.replyBox}>
      {comment.columnCommentReplyList.map((item,index) =>{
          if (index < 2) {
            return(
              <div className={styles.replyItem} key={item.id}>
                <label className={styles.replyUser}>{item.member.nickname}：</label>
                <label className={styles.replyMsg}>{item.content}</label>
              </div>
            )
          } else {
            return null;
          }
        }
      )}

      <div className={styles.replyItem} onClick={() =>{
        history.push({pathname:'/program/programDetail/commentDetail',state:{comment:comment}});
      }}>
        <label className={styles.replyUser}>共{comment.replyCount}条回复</label>
      </div>
    </div>
  )
}



